import { render, staticRenderFns } from "./AdditionalModifier.vue?vue&type=template&id=35f37079&"
import script from "./AdditionalModifier.vue?vue&type=script&lang=js&"
export * from "./AdditionalModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports